import { IDBPDatabase, openDB } from "idb";

const DB_NAME = "appDatabase";
const STORE_NAME = "localStorageFallback";

class Database {
  private static instance: Database;
  private dbPromise: Promise<IDBPDatabase>;

  private constructor() {
    this.dbPromise = openDB(DB_NAME, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      },
    });
  }

  public static getInstance(): Database {
    if (!Database.instance) {
      Database.instance = new Database();
    }
    return Database.instance;
  }

  private async getDB(): Promise<IDBPDatabase> {
    return this.dbPromise;
  }

  public async saveToIndexedDB(key: string, value: unknown): Promise<void> {
    try {
      const db = await this.getDB();
      const tx = db.transaction(STORE_NAME, "readwrite");
      await tx.objectStore(STORE_NAME).put(value, key);
      await tx.done;
    } catch (error) {
      console.error("Error saving to IndexedDB:", key, error);
    }
  }

  public async getFromIndexedDB(key: string): Promise<unknown | null> {
    try {
      const db = await this.getDB();
      return db.transaction(STORE_NAME).objectStore(STORE_NAME).get(key);
    } catch (error) {
      console.error("Error getting from IndexedDB:", key, error);
      return null;
    }
  }

  public async deleteFromIndexedDB(key: string): Promise<void> {
    try {
      const db = await this.getDB();
      await db.delete(STORE_NAME, key);
    } catch (error) {
      console.error(`Error deleting key "${key}" from IndexedDB:`, error);
    }
  }
}

export const indexedDBInstance = Database.getInstance();
